import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";


const images = [
  "/images/main_1.jpg",
  "/images/main_2.jpg",
  "/images/main_3.jpg",
  "/images/main_4.jpg",
  "/images/main_5.png",
  "/images/main_6.png",
  "/images/main_7.jpg",
]

export default function ParallaxSection({
  gotoCompanyInfo,
}) {

  const { t } = useTranslation();

  const [current, setCurrent] = useState(0)
  const [offset, setOffset] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      setOffset(window.pageYOffset);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % images.length)
  }

  useEffect(() => {

    const timer = setInterval(nextSlide, 5000)

    return () => clearInterval(timer)

  }, [])

  return (
    <section className="relative w-full h-screen overflow-hidden flex items-center justify-center text-white font-[Paperozi]">

      {/* images */}
      {images.map((img, index) => (
        <div
          key={index}
          className={`absolute w-full h-[120%] bg-cover bg-center transition-opacity duration-1000 ${index === current ? "opacity-100" : "opacity-0"
            }`}
          style={{
            backgroundImage: `url(${img})`,
            transform: `translateY(${offset * 0.4}px)`
          }}
        />
      ))}

      {/* overlay */}
      <div className="absolute inset-0 bg-black/40"></div>

      <div className="relative text-center w-full px-6">
        <h1 className="text-6xl md:text-2xl font-bold mb-6 md:mb-4 text-white">
          KOREA TRAVEL STORE
        </h1>
        <p className="text-base md:text-sm">
          {t("title.sub")}
        </p>
        <div className="mt-5 md:mt-4 flex justify-center">
          <div
            className="w-fit px-12 py-3 md:px-8 md:py-2.5 bg-[#4A9EE0] rounded-full font-bold font-[Paperozi] text-[20px] md:text-[16px] cursor-pointer"
            onClick={() => gotoCompanyInfo()}
          >
            {t("contact.sub")}
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 md:bottom-6 flex gap-3 md:gap-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-3 h-3 md:w-2.5 md:h-2.5 rounded-full transition ${index === current ? "bg-white scale-125" : "bg-white/50"
              }`}
          />
        ))}
      </div>

    </section>
  );
}